import { RootState } from '../../../Redux/store'

export const selectorPromocode = (state: RootState) => state.promocode.code
export const selectorPromocodeDiscount = (state: RootState) =>
  state.promocode.discount
export const selectorPromocodeError = (state: RootState) =>
  state.promocode.error
